import React from "react";

const Banner = () => {
	return (
			<header>
				<div className="headerText">
					<div>
						<h1><strong>Uz</strong>Auto Online Dokoni</h1>
						<p>Bizning UzAvto Online Dokonimizga Xush Kelibsiz!</p>
					</div>
				</div>
			</header>
		)
}

export default Banner;